import { FC, useEffect } from "react";

import React from "react";
import arrow from "../../assets/images/icon_tab/arrow.svg";
import { Link, useNavigate } from "react-router-dom";
interface TabsMobileProps {
  name?: string;
  backUrl?: string;
}
const TabsMobile: FC<TabsMobileProps> = (props): JSX.Element => {
  const navigate = useNavigate();
  return (
    <>
      <section className="flex flex-tow items-center z-50">
        <div
          onClick={() => {
            // navigate(`/${props.backUrl}`):
            navigate(-1);
          }}
          className="flex bg-white rounded-2xl border-1 border-solid border-gray-400  w-12 h-12 justify-center items-center p-2 active:bg-gray-300"
        >
          <img
            src={arrow}
            style={{ width: 6, height: 12 }}
            className="m-auto"
          />
        </div>

        <h1 className="font-montserrat font-bold text-base text-black m-auto relative -left-6">
          {props.name}
        </h1>
      </section>
    </>
  );
};

export default TabsMobile;
